<template>
    <the-header></the-header>
    
    <router-view v-slot="slotProps">
<transition name="route" mode="out-in">
  <component :is="slotProps.Component"/>
</transition>

    </router-view>
</template>
<script>
import TheHeader from './components/UI/TheHeader.vue'
export default {
    components:{
        TheHeader
    },
    created(){
      this.$store.dispatch('tryLogin');
    },
    watch : {
      didAutoLogout(currentValue,previousValue){
        if(currentValue !== previousValue){
          this.$router.replace('/coaches')
        }
      }
    },
    computed:{
      didAutoLogout(){
        return this.$store.getters.didAutoLogout
      }
    }
}
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap");

* {
  box-sizing: border-box;
}

html {
  font-family: "Roboto", sans-serif;
}

body {
  margin: 0px;
}

.route-enter-from{
  opacity:0;
  transform: scaleY(-50px)
}

.route-enter-active{
  transition: all 0.3s ease-out;
}

.route-enter-to{
 opacity:1;
 transform:scaleY(0px);
}

.route-leave-from{
  opacity:1;
  transform:scaleY(0px);
}
.route-leave-active{
 transition: all 0.3s ease-in;
}

.route-leave-to{
  opacity:0;
  transform:scaleY(30px);
}
</style>